import React from 'react'
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'

// Interface for individual transaction details
export interface WalletTransactionDetail {
  company_name: string
  transaction_date_time: string
  transaction_type: string
  transaction_id: string
  booking_id: string
  booking_date: string
  product: string
  debit: number
  credit: number
  wallet_balance: number
  mode: string
  comment: string
}

// Interface for the API response
export interface WalletStatementApiResponse {
  status: string
  status_code: number
  message: string
  data: {
    wallet_statement_details: WalletTransactionDetail[]
    transaction_date_range: string
    total_transactions: number
    opening_balance: number
    total_debit: number
    total_credit: number
    closing_balance: number
  }
  error: string
  timestamp: string
}
interface WalletStatementListProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  walletStatementData: any
}

export default function WalletStatementList({
  walletStatementData
}: WalletStatementListProps) {
  const transactionDetails = walletStatementData?.wallet_statement_details || []
  const summaryData = walletStatementData

  return (
    <Box sx={{ p: 3 }}>
      {/* Summary Table */}
      <TableContainer component={Paper} elevation={1} sx={{ mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ fontWeight: 'bold', backgroundColor: 'grey.50' }}
              >
                Transaction Date Range
              </TableCell>
              <TableCell
                sx={{ fontWeight: 'bold', backgroundColor: 'grey.50' }}
              >
                Total Transactions
              </TableCell>
              <TableCell
                sx={{ fontWeight: 'bold', backgroundColor: 'grey.50' }}
              >
                Opening Balance
              </TableCell>
              <TableCell
                sx={{ fontWeight: 'bold', backgroundColor: 'grey.50' }}
              >
                Total Debit
              </TableCell>
              <TableCell
                sx={{ fontWeight: 'bold', backgroundColor: 'grey.50' }}
              >
                Total Credit
              </TableCell>
              <TableCell
                sx={{ fontWeight: 'bold', backgroundColor: 'grey.50' }}
              >
                Closing Balance
              </TableCell>
            </TableRow>
          </TableHead>
          {summaryData && (
            <TableBody>
              <TableRow>
                <TableCell>
                  {summaryData?.transaction_date_range || '-'}
                </TableCell>
                <TableCell>{summaryData?.total_transactions || 0}</TableCell>
                <TableCell>{summaryData?.opening_balance || 0}</TableCell>
                <TableCell>{summaryData?.total_debit || 0}</TableCell>
                <TableCell>{summaryData?.total_credit || 0}</TableCell>
                <TableCell>{summaryData?.closing_balance || 0}</TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
        {transactionDetails.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <Typography color='text.secondary' variant='h6'>
              No access data found
            </Typography>
            <Typography color='text.secondary' variant='body2' sx={{ mt: 1 }}>
              Search for a company to view their access information
            </Typography>
          </Box>
        )}
      </TableContainer>
    </Box>
  )
}
